<template>
  <Modal
  :value="() => {}"
  :onClose="() => {}"
  :close="false"
  size="tiny"
  title="Pagamento com cartão"
  >
    <b-row class="form-group center">
      <b-col sm="12">
        <p>Selecione a forma de finalização de venda do cartão:</p>
      </b-col>
    </b-row>
    <b-row class="form-group center">
      <b-col>
        <Button fullWidth="true" :align="'center'" type="success" @click="handleSubmitZpos()">Venda POS</Button>
      </b-col>
    </b-row>
    <b-row class="form-group center">
      <b-col>
        <Button fullWidth="true" :align="'center'" type="success" @click="handleSubmitZposTransaction()">POS integrado</Button>
      </b-col>
    </b-row>
    <b-row class="form-group center">
      <b-col>
        <Button fullWidth="true" :align="'center'" type="white" @click="handleCancelZpos()">Cancelar</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';

export default {
  name: 'ModalZpos',
  components: {
    Modal,
    Button,
  },
  props: {
    submitZpos: {
      type: Function,
      required: true,
    },
    submitZposTransaction: {
      type: Function,
      required: true,
    },
    cancelZpos: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async handleSubmitZpos() {
      return this.submitZpos();
    },
    async handleSubmitZposTransaction() {
      return this.submitZposTransaction();
    },
    async handleCancelZpos() {
      return this.cancelZpos();
    },
  },
};
</script>

<style>
  .center {
    text-align: center!important;
  }
</style>
